export default __webpack_public_path__ + "static/media/logo.a142e251.png";